export enum StorageResource {
  S3 = 'S3',
  GDRIVE = 'GDRIVE',
}

export interface GoogleDriveDoc {
  pendingUpload?: boolean | null;
  uploadFailed?: boolean | null;
  description?: string;
  driveSuccess?: boolean;
  path?: string;
  embedUrl: string;
  iconUrl: string;
  id: string;
  lastEditedUtc: number;
  mimeType: string;
  name: string;
  parentId?: string;
  serviceId?: string;
  sizeBytes?: number;
  type?: string;
  url: string;
  parentUrl: string | null;
  isExternalDoc: boolean;
  size?: number;
  lastModified?: number;
}
